module.exports = __webpack_public_path__ + "images/content-furniture.6a57de50cd907c8d7646d5d9672b5bde.svg";